import forge from "node-forge";
import axios from "axios";

let cachedKey = null;

async function getPublicKey() {
  if (cachedKey) {
    return cachedKey;
  }

  const response = await axios.get("utility/auth-public-key");
  const pem = response && response.data && response.data.data;

  if (typeof pem !== "string" || pem.indexOf("BEGIN PUBLIC KEY") === -1) {
    throw new Error("Auth public key is unavailable");
  }

  cachedKey = forge.pki.publicKeyFromPem(pem);
  return cachedKey;
}

export function prefetchPublicKey() {
  getPublicKey().catch(() => {});
}

/**
 * RSA-OAEP (SHA-1) with the server public key. PHP decrypts this with
 * openssl_private_decrypt and OPENSSL_PKCS1_OAEP_PADDING.
 */
export async function encryptCredential(plaintext) {
  const key = await getPublicKey();
  const bytes = forge.util.encodeUtf8(plaintext);
  const encrypted = key.encrypt(bytes, "RSA-OAEP");
  return forge.util.encode64(encrypted);
}
